import API from "../../../api";
import ENDPOINTS from "../../../../config/apiendpoint";
import C from "../../../constants";

export default class FetchManagerNameAPI extends API {
  constructor( projectId,timeout = 2000) {
    super("GET", timeout, false);
    this.type = C.GET_MANAGER_NAME;
    this.endpoint = `${super.apiEndPointAuto()}${ENDPOINTS.userList}`;
  }

  processResponse(res) {
    super.processResponse(res);
    if (res) {
      this.report = res;
    }
  }

  apiEndPoint() {
    return this.endpoint;
  }

  getBody() {}

  getHeaders() {
    this.headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    };
    return this.headers;
  }

  getPayload() {
    return this.report;
  }
}
